<template>
    <div :class="[{'main-content main-content--wide main-content--profile': !isPayer}, {'main-content--profile-payer': isPayer}]" v-if="userData">

        <div class="row--header" v-if="!isPayer">
            <app-common-header></app-common-header>
        </div>

        <hr v-if="!isPayer" class="separator"/>

        <div class="main-section main-section--page-aside" :class="{'height-auto': !isPayer}">

          <div class="page-container">
            <div class="notifications-buttons">
                <span>
                  {{ $t("notifications_channels") }}
                </span>
              <div class="notification-btn">
                <template
                    v-if="viberHas"
                >
                  <button class="btn" @click="handleViberForNotification" type="button">
                    <img :src="env.public_base + '/assets/images/viber.png'" alt="Viber" class="icon" />
                    {{ viberBtnText }}
                  </button>
                </template>
                <template
                    v-else
                >
                  <a class="btn" :href="viberLink" type="button" target="_blank">
                    <img :src="env.public_base + '/assets/images/viber.png'" alt="Viber" class="icon" />
                    {{ viberBtnText }}
                  </a>
                </template>
              </div>
              <div class="notification-btn">
                <button class="btn" @click="handleTelegramForNotification" type="button">
                  <img :src="env.public_base + '/assets/images/telegram.png'" alt="Telegram" class="icon" />
                  {{ telegramBtnText }}
                </button>
              </div>
            </div>


            <form action="" class="form form--profileform" :class="{'row form--profileform-payer': isPayer}" novalidate="novalidate"
                  @submit.prevent="validateBeforeSubmit">

              <div :class="{'col-md-6': isPayer}">
                <div class="form-field form-field--extended">
                  <label for="fileInput">{{ $t('photo') }}</label>

                  <img :src="avatar | imgSrc" alt="">

                  <div class="form-field--input-editor">
                    <div class="file-field">
                      <input ref="fileInput" type="file" id="fileInput" :title="$t('upload_file')"
                             v-validate="'image'" name="photo"
                             @change="readPhotoURL">
                      <p class="field__error" v-if="errors.has('photo')">{{ errors.first('photo') }}</p>
                    </div>
                    <button v-if="false" class="button" type="button">{{ $t('upload') }}</button>
                  </div>
                </div>

                <div class="form-field" v-if="!!userData.username">
                  <label for="surname">{{ $t('admin_login') }}</label>
                  <input type="text" id="adminLogin" :value="userData.username" disabled="disabled">
                </div>

                <div class="form-field">
                  <label for="surname">{{ $t('surname') }}</label>
                  <input type="text" id="surname" :value="userData.last_name" disabled="disabled">
                </div>

                <div class="form-field">
                  <label for="name">{{ $t('name') }}</label>
                  <input type="text" id="name" :value="userData.first_name" disabled="disabled">
                </div>

                <div class="form-field">
                  <label for="patronymic">{{ $t('patronymic') }}</label>
                  <input type="text" id="patronymic" :value="userData.patronymic" disabled="disabled">
                </div>

                <div class="form-field">
                  <label for="login">{{ $t('login') }}</label>
                  <input type="text" id="login" :value="userData.email" disabled="disabled">
                </div>

                <div class="form-field">
                  <label for="phone_">{{ $t('phone') }}</label>
                  <input type="text" id="phone_" v-model="phone_" name="phone_"
                         v-validate="{required: true, min: 10}">

                  <p class="field__error" v-if="errors.has('phone_')">{{ errors.first('phone_') }}</p>
                </div>

                <div class="form-field">
                  <label for="password_">{{ $t('password') }}</label>
                  <input type="password" id="password_"
                         v-validate="{ required: this.newPassword !== '' || this.confirmPassword !== '' }"
                         v-model="password_" name="password_">
                  <p class="field__error" v-if="errors.has('password_')">{{ errors.first('password_') }}</p>
                </div>

                <div class="form-field">
                  <label for="newPassword">{{ $t('new_password') }}</label>
                  <input type="password" id="newPassword"
                         v-validate="{ required: this.password_ !== '' || this.confirmPassword !== '' }"
                         v-model="newPassword" name="newPassword">
                  <p class="field__error" v-if="errors.has('newPassword')">{{ errors.first('newPassword') }}</p>
                </div>

                <div class="form-field">
                  <label for="confirmPassword">{{ $t('confirm_new_password') }}</label>
                  <input type="password" id="confirmPassword"
                         v-validate="{ required: this.newPassword !== '' || this.password_ !== '', confirmed: newPassword }"
                         v-model="confirmPassword" name="confirmPassword">
                  <p class="field__error" v-if="errors.has('confirmPassword')">{{
                      errors.first('confirmPassword')}}</p>
                </div>

                <!--
                        <div class="form-field">
                            <label for="moodleLogin">{{ $t('moodle_login') }}</label>
                            <input type="text" id="moodleLogin" v-validate="{ required: this.moodlePassword !== '' }" v-model="moodleLogin" name="moodleLogin">
                            <p class="field__error" v-if="errors.has('moodleLogin')">{{ errors.first('moodleLogin') }}</p>
                        </div>

                        <div class="form-field">
                            <label for="moodlePassword">{{ $t('moodle_password') }}</label>
                            <input type="password" id="moodlePassword" v-validate="{ required: this.moodleLogin !== '' }" v-model="moodlePassword" name="moodlePassword">
                            <p class="field__error" v-if="errors.has('moodlePassword')">{{ errors.first('moodlePassword') }}</p>
                        </div>
                -->
              </div>
              <div :class="{'col-md-6': isPayer}" v-if="isPayer && (userData.role === 'billing' || userData.role === 'student/billing')">
                <div class="form-field">
                  <label for="login">{{ $t('inn') }}*</label>
                  <input v-model="inn_" type="text" id="inn" name="inn_" v-validate="{required: true}">
                  <p class="field__error" v-if="errors.has('inn_')">{{ errors.first('inn_') }}</p>
                </div>
                <div class="form-field">
                  <label for="passport">{{ $t('passport') }}*</label>
                  <input v-model="passport_" type="text" id="passport" name="passport_" v-validate="{required: true}">
                  <p class="field__error" v-if="errors.has('passport_')">{{ errors.first('passport_') }}</p>
                </div>
                <div class="form-field">
                  <label for="issued_passport">{{ $t('issued_passport') }}*</label>
                  <input v-model="issued_passport_" type="text" id="issued_passport" name="issued_passport_" v-validate="{required: true}">
                  <p class="field__error" v-if="errors.has('issued_passport_')">{{ errors.first('issued_passport_') }}</p>
                </div>
                <div class="form-field">
                  <label for="date_passport_from">{{ $t('date_passport_from') }}*</label>
                  <input v-model="date_passport_from_" type="text" id="date_passport_from" name="date_passport_from_" v-validate="{required: true}">
                  <p class="field__error" v-if="errors.has('date_passport_from_')">{{ errors.first('date_passport_from_') }}</p>
                </div>
                <div class="form-field">
                  <label for="date_passport_to">{{ $t('date_passport_to') }}</label>
                  <input v-model="date_passport_to_" type="text" id="date_passport_to" name="date_passport_to_">
                </div>
                <div class="form-field">
                  <label for="country">{{ $t('user_country') }}*</label>
                  <input v-model="country_" type="text" id="country" name="country_" v-validate="{required: true}">
                  <p class="field__error" v-if="errors.has('country_')">{{ errors.first('country_') }}</p>
                </div>
                <div class="form-field">
                  <label for="address_fact">{{ $t('address_fact') }}*</label>
                  <input v-model="address_fact_" type="text" id="address_fact" name="address_fact_" v-validate="{required: true}">
                  <p class="field__error" v-if="errors.has('address_fact_')">{{ errors.first('address_fact_') }}</p>
                </div>
              </div>

              <!-- <div :class="{'col-md-6': isPayer}">
                  <div class="form-field">
                      <label>{{ $t('language') }}</label>
                      <Languages
                          v-if="$route.name === 'profile'"
                          class="profile-lang"
                      />
                  </div>
              </div> -->

              <div class="col-12" :class="{'col-md-12': isPayer}">
                <hr class="separator separator--wide">

                <div class="button-container">
                  <button class="button button--accent button--profile" type="submit"
                          :disabled="fileSizeLimitData"
                  >
                    {{ $t('save_changes') }}
                  </button>

                  <button class="button button--regular button--profile" type="reset"
                          @click.prevent="resetForm"
                  >
                    {{ $t('cancel') }}
                  </button>
                </div>
              </div>

            </form>

          </div>
            <app-notification-alert v-if="notification && notification.isActive"></app-notification-alert>

        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import env from '../env';
    import NotificationAlert from './NotificationAlert.vue';
    import MoodleLoginForm from "./MoodleLoginForm";
    import Header from "./Header";
    // import Languages from "../chats/components/Languages";

    export default {
        data: () => ({
            password_: '',
            newPassword: '',
            confirmPassword: '',
            photo: '',
            phone_: '',
            inn_: '',
            date_passport_from_: '',
            date_passport_to_: '',
            country_: '',
            address_fact_: '',
            passport_: '',
            issued_passport_: '',
            avatarUrl: null,
            env,
            moodleLogin: '',
            moodlePassword: '',
            fileSizeLimitData: false
        }),
        computed: {
            ...mapGetters([
                'userData',
                'notification',
            ]),
            avatar() {
                return this.avatarUrl ? this.avatarUrl : this.userData.photo;
            },
            isPayer() {
                return this.$router.options.base.indexOf('payer') > -1 ;
            },

            channelNames() {
              const channelNames = [];
              for (const channel of this.userData.notifications_channels) {
                channelNames.push(channel.channel_name);
              }
              return channelNames;
            },

            viberHas() {
              return this.channelNames.includes("Viber")
            },

            telegramHas() {
              return this.channelNames.includes("Telegram")
            },

            viberBtnText() {
              return this.viberHas ?
                  this.$t("disconnect_viber") : this.$t('connect_viber');
            },
            telegramBtnText() {
              return this.telegramHas ?
                  this.$t("disconnect_telegram") : this.$t('connect_telegram');
            },

            viberLink() {
              return this.env.viber_bot_url + this.userData.external_id;
            },

            telegramLink() {
              return this.env.telegram_bot_url + this.userData.external_id;
            },

        },
        watch: {
            userData() {
                this.phone_ = this.userData.phone;
                this.inn_ = this.userData.inn;
                this.date_passport_from_ = this.userData.date_passport_from;
                this.date_passport_to_ = this.userData.date_passport_to;
                this.country_ = this.userData.country;
                this.address_fact_ = this.userData.address_fact;
                this.passport_ = this.userData.passport;
                this.issued_passport_ = this.userData.issued_passport;
            }
        },
        methods: {
            validateBeforeSubmit() {
                let $vm = this;
                $vm.$validator.validateAll().then((result) => {
                    if (result) {

                        let file_data = document.getElementById("fileInput").files[0];
                        let form_data = new FormData();

                        if (typeof file_data !== "undefined") {
                            form_data.append('photo', file_data);
                        }

                        if ($vm.password_ !== '') {
                            form_data.append('password', $vm.password_);
                            form_data.append('new_password', $vm.newPassword);
                            form_data.append('confirm_new_password', $vm.confirmPassword);
                        }

                        if ($vm.phone_ !== '') {
                            form_data.append('phone', $vm.phone_);
                        }

                        if ($vm.inn_ !== '') {
                            form_data.append('inn', $vm.inn_);
                        }

                        if ($vm.date_passport_from_ !== '') {
                            form_data.append('date_passport_from', $vm.date_passport_from_);
                        }

                        form_data.append('date_passport_to', $vm.date_passport_to_);

                        if ($vm.country_ !== '') {
                            form_data.append('country', $vm.country_);
                        }

                        console.log($vm.country_)

                        if ($vm.address_fact_ !== '') {
                            form_data.append('address_fact', $vm.address_fact_);
                        }

                        if ($vm.passport_ !== '') {
                            form_data.append('passport', $vm.passport_);
                        }

                        if ($vm.issued_passport_ !== '') {
                            form_data.append('issued_passport', $vm.issued_passport_);
                        }

                        if ($vm.moodleLogin !== '') {
                            form_data.append('moodle_login', $vm.moodleLogin);
                            form_data.append('moodle_password', $vm.moodlePassword);
                        }

                        form_data.append('lang', localStorage.getItem('language'));

                        console.log(form_data)

                        if ($vm.moodleLogin !== '' || $vm.password_ !== '' || typeof file_data !== "undefined" || $vm.phone_ !== "" || $vm.country_ !== '') {
                            $vm.$store.dispatch('user', form_data).then(res => {
                                this.showNotificationAlert(res.data.msg);
                                this.resetForm();

                                $vm.$store.dispatch('whoami');
                            })
                                .catch(err => {
                                    if (err && err.msg) {
                                        this.showNotificationAlert(err.msg)
                                    } else {
                                        this.showNotificationAlert(this.$t('saving_failed'));
                                    }

                                })
                        }
                    }
                });
            },
            showNotificationAlert(text) {
                this.$store.commit('SET_NOTIFICATION_ALERT', {text: text, isActive: true});
            },
            hideNotificationAlert() {
                this.$store.commit('SET_NOTIFICATION_ALERT', {});
            },
            readPhotoURL(ev) {
                let $vm = this;
                const file = ev.target.files[0];
                this.fileSizeLimitData = false;

                let FileSize = file.size / 1024 / 1024; // in MB
                
                if (FileSize > 10) {
                    this.showNotificationAlert(this.$t('file_size_limit'));
                    this.fileSizeLimitData = true;
                }
                const reader = new FileReader();
                reader.onload = e => $vm.avatarUrl = e.target.result;
                reader.readAsDataURL(file);
            },
            resetForm() {
                this.password_ = '';
                this.newPassword = '';
                this.confirmPassword = '';
                const input = this.$refs.fileInput;
                input.value = null;
                this.avatarUrl = null;
                this.moodleLogin = '';
                this.moodlePassword = '';
            },
            handleTelegramForNotification() {
                if (!this.telegramHas) {
                  window.location.href = this.telegramLink;
                } else {
                  let id;
                  for (const channel of this.userData.notifications_channels) {
                    if (channel.channel_name === 'Telegram') {
                      id = channel.id;
                    }
                  }
                  if (id) this.$store.dispatch('deleteNotificationChannelSetting', id);
                }
            },
            handleViberForNotification() {
                if (!this.viberHas) {
                  window.location.href = this.viberLink;
                } else {
                  let id;
                  for (const channel of this.userData.notifications_channels) {
                    if (channel.channel_name === 'Viber') {
                      id = channel.id;
                    }
                  }
                  if (id) this.$store.dispatch('deleteNotificationChannelSetting', id);
                }
            }

        },

        created() {
            this.phone_ = this.userData.phone;
            this.inn_ = this.userData.inn;
            this.date_passport_from_ = this.userData.date_passport_from;
            this.date_passport_to_ = this.userData.date_passport_to;
            this.country_ = this.userData.country;
            this.address_fact_ = this.userData.address_fact;
            this.passport_ = this.userData.passport;
            this.issued_passport_ = this.userData.issued_passport;
        },

        components: {
            appNotificationAlert: NotificationAlert,
            appMoodleLoginForm: MoodleLoginForm,
            appCommonHeader: Header,
            // Languages,
        },
    }
</script>

<style lang="sass">
    @import '../../sass/variables'
    @import '../../sass/payer'

    .profile-lang
        position: static

    .btn
      display: flex
      align-items: center
      gap: 8px
      padding: 10px 20px
      border: none
      border-radius: 5px
      cursor: pointer
      font-size: 16px
      background-color: #f0f0f0
      transition: background-color 0.2s
      margin-right: 5px

    .btn:hover
      background-color: #e0e0e0

    .icon
      width: 24px
      height: 24px

    .notifications-buttons
      display: flex
      justify-content: space-around
      max-width: 480px

</style>